export type WholeNumberInput = { readonly ok: true; readonly value: number | null } | { readonly ok: false };

/**
 * A whole-number text field as typed. Blank is "no value"; anything else must
 * be plain digits, surrounding whitespace aside, within `min`..`max`.
 * `Number` alone would also take "1e1", "0x10", "10.0" or "+10".
 */
export function parseWholeNumberInput(
  raw: string,
  range: { readonly min: number; readonly max: number },
): WholeNumberInput {
  const trimmed = raw.trim();
  if (trimmed === '') return { ok: true, value: null };
  if (!/^[0-9]+$/.test(trimmed)) return { ok: false };
  const n = Number(trimmed);
  return n >= range.min && n <= range.max ? { ok: true, value: n } : { ok: false };
}
